// extracted by mini-css-extract-plugin
export var visionSection = "Vision-module--visionSection--N6w7H";
export var visionSphere = "Vision-module--visionSphere--NOu15";
export var visionSphereLine = "Vision-module--visionSphereLine--EE2+E";
export var fadeUp = "Vision-module--fade-up--TdebO";
export var easeInLine = "Vision-module--ease-in-line--qROSf";
export var visionBgSection = "Vision-module--visionBgSection--mEs5N";
export var vidionMainBg = "Vision-module--vidionMainBg--6vX3A";
export var visionBg = "Vision-module--visionBg---r0FL";